const __request = require(`./__request/__request_contentType_json`);

// 行程单物流列表
const recordCount = (data) => {
let pParameter = {
    method: 'post',
    // urlSuffix: '/flight/domestic/buyer/manage/itineraryOrder/logistics',
    urlSuffix:'/buyer/dom/manage/itinerary/mailing/list',
    data:data
  }

  return __request(pParameter)
}
export default recordCount
